module.exports = __webpack_public_path__ + "static/media/12thSlide.022523e2.mp3";